import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { Grid, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { Label } from 'core/components/label';
import useStyles from '../../dialog.styles';
import { policyTypes } from '@ourbranch/policy-types';
import { DriverCard } from './components/driver-card';
import { MVRErrors } from 'core/store/offer-store/offer-store';

// this component also handles the drivers_changed error case
const MVRRejected = observer(function MVRFailure() {
  const { offer: store } = useStore();
  const history = useHistory();
  const classes = useStyles();

  // the lambda will return the results of the MVR calls in the error message as err.data
  const error = store.errors.find(
    (err) => MVRErrors[err.code] === MVRErrors.MVR_REJECTED || MVRErrors[err.code] === MVRErrors.MVR_DRIVERS_CHANGED
  );

  /** if the error is mvr_rejected, only show the x on the primary becuase we don't know which driver caused the rejection.
   * if a driver was dropped or exclude indicate that driver
   * */
  const getDriverStatus = (driver) => {
    if (!canResolve) {
      if (driver.isPrimary) {
        return 'failed';
      }
      return '';
    }
    return driver.exlcludeDriver ? 'failed' : 'success';
  };

  const onClick = () => {
    store.triggerOfferDialog(false);
  };

  const switchToHomeowners = () => {
    store.triggerOfferDialog(false);
    store.setSelectedOption('H');
    history.push({ pathname: `/offer/${store.offer.id}` });
  };

  const backToOffer = () => {
    store.triggerOfferDialog(false);
    history.push({ pathname: `/offer/${store.offer.id}` });
  };

  // rules for which message to show
  // if driver with no/bad MVR is priamry or coapp, this cannot be rectified -> offer to switch to home only if bundle
  // if the driver is not primary/coapp they can be excluded -> return to offer
  const canResolve = !(MVRErrors[error.code] === MVRErrors.MVR_REJECTED);

  const cantResolveBundle = !canResolve && store.offer.quote.selectedOption === policyTypes.HABundle; // can switch to home only

  let errorMessage =
    'One or more drivers on this offer have incidents on their motor vehicle record that disqualifies them from purchasing auto insurance with Branch.';
  if (cantResolveBundle && Error) {
    errorMessage += ' We can still give you an offer for Homeowners.';
  }
  if (canResolve) {
    errorMessage += ' Return to the offer to exclude the affected drivers.';
  }

  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Purchase Failed
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        {errorMessage}
      </Label>

      {error.data.map((driver, idx) => {
        const status = getDriverStatus(driver);
        return <DriverCard key={idx} driver={driver} status={status} />;
      })}

      <Grid container alignItems="center" justifyContent="flex-end" className={classes.bottom}>
        {canResolve && (
          <Button onClick={backToOffer} variant="contained" color="primary" className={classes.btn}>
            <Label className={classes.btnLabel}>Back To Offer</Label>
          </Button>
        )}
        {cantResolveBundle && (
          <>
            <Button onClick={switchToHomeowners} variant="text" color="secondary" className={classes.btnSmall}>
              <Label className={classes.btnLabel}>Switch To Homeowners</Label>
            </Button>
            <Button onClick={onClick} variant="contained" color="primary" className={classes.btnSmall}>
              <Label className={classes.btnLabel}>Return to Checkout</Label>
            </Button>
          </>
        )}
      </Grid>
    </>
  );
});

export default MVRRejected;
